import { Point, Rectangle, Matrix } from "../Utils/Matrix";
import { TopoNode } from "../Topology/TopoNode";

export class TopoConnection {
	public get Node(): TopoNode {
		return null
	}

	public ConnectionPoint(): Point {
		if (this.Node)
			return this.Node.ConnectionLocation(this);
		else
			return new Point();
	}

	public get DisplayName(): string {
		return "";
	}
}
